// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer-module--Footer--1VU2P","SocialLinks":"footer-module--SocialLinks--1DoCk"};